module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC6SURBVHgB7ZSNDcIgEIVP4gCO4AgdwVHcwBF0g7qBdgLjBLiBIxgnwA3O14RLLqQSU2jTvy+5UK7wXoADooVRwcxHhOM8lL9MdpyfveibBs/HKhFoVKGooZ6YoREO9IWwqn+rc6pf+jGb1kZq8kelQ8G3z0WNtKiUt6VEoHH9p7w7YXpG69hP7HGB5oIoqB1OPkzE5IDGJphUeI3uTcJSdU9/N4Qz5aTepuDldbo8c5ud/IosYksLQ+ALc7Akjqy6LJcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Chat_Dots.png
// module id = bnxM
// module chunks = 1